export const dataEncoding = (text) => {
    const encodingData = encodeURIComponent(text);
    return encodeURIComponent(encodingData.replace(/%20/g, ' ')).replace(/%20/g, ' ');
}

export const dataDecoding = (text) => {
    const decodingData = decodeURIComponent(text);
    return decodeURIComponent(decodeURIComponent(decodingData));
}